<template>
    <div class="flex flex-col space-y-2 mt-2">
        <div class="relative">
            <input
                type="text"
                id="datepicker"
                class="form-input block w-full pl-10"
                :placeholder="label"
                ref="datepicker"
                v-model="selectedDates"
                @focus="focus"
                @select="select"
            />
            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <icon name="calendar" />
            </div>
        </div>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
import Flatpickr from 'flatpickr';
import Icon from "@/Shared/Icon.vue";

export default {
    components: {Icon},
    props: {
        label: {
            type: String,
            default: 'Дата рибалки',
        },
        modelValue: {
            type: Array,
            default: () => [],
        },
        disabledDays: {
            type: Array,
            default: () => [],
        },
        error: String,
    },
    data() {
        return {
            selectedDates: this.modelValue.join(' - '),
        };
    },
    emits: ['update:modelValue'],
    watch: {
        disabledDays() {
            this.initFlatpickr();
        },
        modelValue(newVal) {
            this.selectedDates = newVal.join(' - ');
        },
    },
    mounted() {
        this.initFlatpickr()
    },
    methods: {
        initFlatpickr() {
            this.selectedDates = []
            Flatpickr(this.$refs.datepicker, {
                locale: {
                    firstDayOfWeek: 1
                },
                mode: 'range',
                disable: this.disabledDays,
                altFormat: "DD-MM-YYYY",
                onClose: (selectedDates) => {
                    this.$emit('update:modelValue', selectedDates.map(date => {
                        const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
                        return localDate.toISOString().slice(0, 10);
                    }));
                }
            });
        },
        focus() {
            this.$refs.datepicker.focus();
        },
        select() {
            this.$refs.datepicker.select();
        },
        setSelectionRange(start, end) {
            this.$refs.datepicker.setSelectionRange(start, end);
        },
    },
};
</script>
